import PKG from "../../../package.json";
import { useMemo } from "react";

export function useVersion() {
  const version = useMemo(() => {
    if (__DEV__) {
      return `v${PKG.version}-dev`;
    }
    return `v${PKG.version}${process.env.VERCEL_GIT_COMMIT_SHA ? `-${process.env.VERCEL_GIT_COMMIT_SHA?.slice(-7)}` : ""}`;
  }, []);

  return {
    version,
  };
}
